import { render, staticRenderFns } from "./zzwy_xslist.vue?vue&type=template&id=1547e51a&"
import script from "./zzwy_xslist.vue?vue&type=script&lang=js&"
export * from "./zzwy_xslist.vue?vue&type=script&lang=js&"
import style0 from "./zzwy_xslist.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports